
    // IMPORTS
    import { computed, defineComponent, PropType } from 'vue'

    import { BoolField } from '../fields'

    import { buildLocalization } from '@/util'

    export default defineComponent({
        name: 'checkboxCell',

        components: {
            BoolField
        },

        emits: {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            change: (dataItem: Object, checked: boolean) => true
        },

        props: {
            dataItem: { type: Object as PropType<any>, required: true },
            field: { type: String as PropType<string>, required: true },
            className: { type: String as PropType<string>, required: false, default: () => null },
            rowType: { type: String as PropType<string>, required: false, default: () => '' },
            isGroupRender: { type: Boolean as PropType<boolean>, default: () => false },
        },

        setup(props, { emit }) {
            /********************************************************************************************************************
             INIT
             ********************************************************************************************************************/

            /********************************************************************************************************************
             PUBLIC DATA
             ********************************************************************************************************************/
            const publicData = { }

            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const propValue = computed(() => props.dataItem[props.field])
            const computedData = { propValue }

            /********************************************************************************************************************
             PUBLIC METHODS
             ********************************************************************************************************************/
            const { localize } = buildLocalization()

            function onCheckBoxChange(dataItem: Object, checked: boolean) {
                console.log('*** emit ***')
                emit('change', dataItem, checked)
            }

            const publicMethods = { localize, onCheckBoxChange }

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { ...publicData, ...computedData, ...publicMethods }
        }
    });
